import * as React from 'react';

var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var SvgThumbsUpFilled = function SvgThumbsUpFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.611 2.5C10.9567 2.5 10.3546 2.86515 10.054 3.44858L6.42148 10.5H3.75C2.7835 10.5 2 11.2835 2 12.25V19.75C2 20.7165 2.7835 21.5 3.75 21.5H17.422C19.2752 21.5 20.8505 20.1463 21.1293 18.3142L21.9663 12.8142C22.3117 10.5444 20.5548 8.5 18.2589 8.5H13.8921L14.3328 5.67364C14.5932 4.00371 13.2962 2.5 11.611 2.5ZM6 12V20H3.75C3.61193 20 3.5 19.8881 3.5 19.75V12.25C3.5 12.1119 3.61193 12 3.75 12H6Z"
  })));
};

export { SvgThumbsUpFilled as ReactComponent };
//# sourceMappingURL=thumbs--up-filled.svg.js.map
